/**
 * ResponseRoboCnpjCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'

/* TODO: review generated class */
@HttpExclude()
export class ResponseRoboCnpjCollection extends PageCollection<
  ResponseRoboCnpj
> {
  constructor() {
    super(ResponseRoboCnpj)
  }

  queryAsPage() {
    return this.listResponseRoboCnpj()
  }

  async listResponseRoboCnpj() {
    return await Request.get(`/admin/response-robo-cnpj`, {params: this.params})
      .name('listResponseRoboCnpj')
      .as(this)
      .getResponse()
  }

  async listCsvResponseRoboCnpj() {
    return await Request.get(`/admin/response-robo-cnpj/csv`, {
      params: this.params,
    })
      .name('listCsvResponseRoboCnpj')
      .as(this)
      .getResponse()
  }
}
